var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{ref:"cedisPerformanceGraph",staticStyle:{"width":"100%","height":"700px"},on:{"wheel":_vm.forwardWheelToPage}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('strong')])])
}]

export { render, staticRenderFns }